import React, { createContext, useState } from "react";

import "./App.scss";

import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

// pages
import Home from "./pages";
import ImpressumPage from "./pages/impressum";

export const ThemeContext = createContext();

function App() {
  const [overlayOpened, setOverlayOpened] = useState(false);
  const [overlay, setOverlay] = useState(false);
  const [contentVisible, setContentVisible] = useState(false);
  const [overlayTheme, setOverlayTheme] = useState("dark");
  const [visibleSection, setVisibleSection] = useState("home");

  function openOverlay(item) {
    setOverlay(item);
    setOverlayOpened(true);

    setTimeout(() => {
      setContentVisible(true);
    }, 100);
  }

  function closeOverlay() {
    setContentVisible(false);

    setTimeout(() => {
      setOverlayOpened(false);
    }, 300);
  }

  function NotFound() {
    return <h1>404 - Not Found</h1>;
  }

  return (
    <ThemeContext.Provider
      value={{
        overlayOpened,
        setOverlayOpened,
        overlay,
        setOverlay,
        openOverlay,
        closeOverlay,
        contentVisible,
        setContentVisible,
        overlayTheme,
        setOverlayTheme,
        visibleSection,
        setVisibleSection,
      }}
    >
      <Router>
        <Routes>
          <Route index element={<Home />} />
          <Route path="/impressum" element={<ImpressumPage />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </Router>
    </ThemeContext.Provider>
  );
}

export default App;
